<template>
  <div class="icon-title-wrapper">
    <i :class="['icon', 'iconfont', `iconcv-title-icon-${type}`]" :style="{color: theme}"></i>
    <span class="title" :style="{color: theme}">{{ name }}</span>
    <div class="line" :style="{background: theme}"></div>
  </div>
</template>

<script>
export default {
  props: ['name', 'theme', 'type']
}
</script>

<style lang="scss" scoped>
  .icon-title-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .icon {
    font-size: 18px;
    margin-right: 8px;
  }
  .title {
    display: inline-block;
    color: #404040;
    font-size: 16px;
    font-weight: 600;
    word-break: keep-all;
    white-space: nowrap;
    margin-right: 10px;
  }
  .line {
    width: 100%;
    height: 1px;
    background: #404040;
    opacity: 0.12;
  }
</style>
